(function() {
	// globals
	PM.Plan = {};
	PM.Plan.viewMode = 'people';
	PM.Weekly.stripeMode = false;

	PM.Plan.currentMobileMonth = null;

	PM.Plan.isMobile = function() {
		return window.matchMedia('(max-width: 767.98px)').matches;
	};

	// ── Delegated to PM.Weekly ────────────────────────────────

	PM.Plan.colors = PM.Weekly.colors;
	PM.Plan.stripeColors = PM.Weekly.stripeColors;
	PM.Plan.hexToRgb = PM.Weekly.hexToRgb;
	PM.Plan.getCellBgStyle = PM.Weekly.getCellBgStyle;
	PM.Plan.getStripeBgStyle = PM.Weekly.getStripeBgStyle;
	PM.Plan.fetchColors = PM.Weekly.fetchColors;
	PM.Plan.getMonthRange = PM.Weekly.getMonthRange;

	PM.Plan.applyStripeColors = function() {
		PM.Weekly.applyStripeColors('.js-project-row, .js-person-assign-row', '.js-plan-week-input');
	};

	PM.Plan.removeStripeColors = function() {
		PM.Weekly.removeStripeColors('.js-project-row, .js-person-assign-row', '.js-plan-week-input');
	};

	PM.Plan.initColumnResize = function() {
		PM.Weekly.initColumnResize('.js-person-name, .js-project-name, .js-project-name-cell, .js-person-name-cell, .js-col-resize-cell', 'plan-col1-width');
	};

	// app functions

	PM.Plan.getCurrentYear = function() {
		return Number(PM.Plan.getMonthRange().fromMonth.slice(0, 4));
	};

	PM.Plan.deleteVisibleEntries = function(personId, projectId) {
		var person = ((PM.Plan._planData && PM.Plan._planData.people) || []).find(function(item) {
			return Number(item.id) === Number(personId);
		});
		var project = person && person.projects.find(function(item) {
			return Number(item.id) === Number(projectId);
		});
		var ids = new Set(project ? project.plan.map(function(entry) { return entry.id; }) : []);
		$('.js-plan-week-input[data-person-id="' + personId + '"][data-project-id="' + projectId + '"]').each(function() {
			var id = $(this).data('plan-id');
			if (id) ids.add(id);
		});
		return PM.Plan.deleteEntryIds(Array.from(ids));
	};

	PM.Plan.deleteEntryIds = function(ids) {
		return $.when.apply($, ids.map(function(id) {
			return $.ajax({ url: '/api/plan/' + encodeURIComponent(id), method: 'DELETE' });
		}));
	};

	PM.Plan.rowEntryIds = function($row) {
		var ids = new Set();
		$row.find('.js-plan-week-input[data-plan-id]').each(function() {
			var id = $(this).data('plan-id');
			if (id) ids.add(id);
		});
		return Array.from(ids);
	};

	PM.Plan.deleteRowEntries = function($row) {
		return PM.Plan.deleteEntryIds(PM.Plan.rowEntryIds($row));
	};

	PM.Plan.getMonthStartWeeks = function(weekStructure) {
		var monthStartWeeks = new Set();
		var week = 1;
		var monthGroups = weekStructure.monthGroups || [];

		monthGroups.forEach(function(monthGroup) {
			monthStartWeeks.add(week);
			week += monthGroup.colspan;
		});

		return monthStartWeeks;
	};

	// Helper: update the row DOM with a resolved project ID
	PM.Plan.updateRowProjectId = function($row, projectId) {
		$row.attr('data-project-id', projectId);
		$row.data('project-id', projectId);
		$row.find('.js-project-name-select').attr('data-project-id', projectId).data('project-id', projectId);
		$row.find('.js-remove-project-btn').attr('data-project-id', projectId).data('project-id', projectId);
		$row.find('.js-plan-week-input').attr('data-project-id', projectId).data('project-id', projectId);
		$row.removeClass('js-new-project');
	};

	// Helper: update plan-id attributes from the server response
	PM.Plan.updatePlanIds = function($row, savedPlans) {
		savedPlans.forEach(function(saved) {
			var $input = $row.find('.js-plan-week-input[data-per-year-week="' + saved.week + '"][data-year="' + saved.year + '"]');
			if (!$input.length) return;
			$input
				.attr('data-plan-id', saved.id)
				.data('plan-id', saved.id);
			if (saved.hours !== undefined && saved.hours !== null) {
				$input
					.val(i18next.format(saved.hours, 'number', i18next.language, { minimumFractionDigits: 2 }))
					.attr('data-raw-value', saved.hours)
					.data('raw-value', saved.hours);
			}
		});
	};

	// Check if a person has any project rows left; if not, show the "no projects" placeholder
	PM.Plan.checkNoProjectsRow = function(personId) {
		var $existingRows = $(`.js-project-row[data-person-id="${personId}"]`);
		if ($existingRows.length === 0) {
			var $header = $(`.js-person-header[data-person-id="${personId}"]`);
			if ($header.length) {
				$.get('/api/projects').then(function(projects) {
					var ws = PM.Plan.weekStructure || { totalWeeks: PM.Plan.totalWeeks, weeks: [], monthGroups: [] };
					var rowHtml = ejs.rr('/app/plan/templates/project-row.ejs', {
						personId: personId,
						allProjects: projects,
						availableProjects: projects,
						personAbsences: PM.Plan.personAbsencesMap.get(Number(personId)) || [],
						weekStructure: ws,
						monthStartWeeks: PM.Plan.getMonthStartWeeks(ws)
					});
					$header.after(rowHtml);
					var $newRow = $(`.js-project-row[data-person-id="${personId}"]`).last();
					PM.Plan.initProjectChoices($newRow.find('.js-project-name-select'));
					PM.Plan.initColumnResize();
					PM.Weekly.highlightCurrentWeek('.js-weekly-zoom-container', ws);
					if (PM.Weekly.stripeMode) {
						PM.Plan.applyStripeColors();
					}
				});
			}
		}
	};

	// Initialize Choices.js on a project select element.
	// If $select is not provided, initialize all .js-project-name-select elements on the page.
	PM.Plan.initProjectChoices = function($select) {
		var $targets = $select ? $($select) : $('.js-project-name-select');
		$targets.each(function() {
			var $el = $(this);
			// Skip if already initialized
			if ($el.data('choices-instance')) return;

			setTimeout(function() {
				var canManageProjects = PM.Shell.checkPermission('manage_projects');
				var choices = new Choices($el[0], {
					removeItemButton: true,
					searchEnabled: true,
					shouldSort: false,
					addItems: canManageProjects,
					addChoices: canManageProjects,
					addItemText: function(value) {
						return i18next.t('Add project') + ' "' + value + '"';
					},
					noResultsText: i18next.t('No projects found'),
					noChoicesText: i18next.t('Type to search'),
					itemSelectText: '',
					searchPlaceholderValue: i18next.t('Select or type project name'),
					allowHTML: false
				});

				$el.data('choices-instance', choices);
			}, 0);
		});
	};

	// Initialize Choices.js on person select elements (project view)
	PM.Plan.initPersonChoices = function($select) {
		var $targets = $select ? $($select) : $('.js-person-select');
		$targets.each(function() {
			var $el = $(this);
			if ($el.data('choices-instance')) return;

			setTimeout(function() {
				var choices = new Choices($el[0], {
					removeItemButton: true,
					searchEnabled: true,
					shouldSort: false,
					addItems: false,
					noResultsText: i18next.t('No people found'),
					noChoicesText: i18next.t('Type to search'),
					itemSelectText: '',
					searchPlaceholderValue: i18next.t('Select or type person name'),
					allowHTML: false
				});
				$el.data('choices-instance', choices);
			}, 0);
		});
	};

	// Refresh person choices (project view) — exclude already-assigned people
	PM.Plan.refreshPersonChoices = function() {
		var people = PM.Plan.allPeople || [];
		$('.js-person-select').each(function() {
			var $el = $(this);
			var choices = $el.data('choices-instance');
			if (!choices) return;

			var $row = $el.closest('.js-person-assign-row');
			var projectId = $row.data('project-id');
			var rowPersonId = $row.data('person-id');

			var assignedPersonIds = new Set();
			$('.js-person-assign-row[data-project-id="' + projectId + '"]').each(function() {
				var pid = $(this).data('person-id');
				if (pid) assignedPersonIds.add(Number(pid));
			});

			choices.clearStore();
			choices.setChoices([
				{ value: '', label: i18next.t('Select or type person name'), selected: false, disabled: false }
			]);

			var options = people
				.filter(function(p) {
					return !assignedPersonIds.has(Number(p.id)) || Number(p.id) === Number(rowPersonId);
				})
				.map(function(p) {
					return { value: String(p.id), label: p.name, selected: Number(p.id) === Number(rowPersonId) };
				});
			choices.setChoices(options, 'value', 'label', false);
		});
	};

	// Helper: transform person-grouped plan data into project-grouped data
	PM.Plan.transformToProjectView = function(planData, allProjects, projectStatuses) {
		var projectMap = new Map();
		var allPeople = planData.people || [];
		var statuses = projectStatuses || {};
		var peopleList = allPeople.map(function(p) {
			return { id: Number(p.id), name: p.name, workhours: p.workhours };
		});

		for (var i = 0; i < allPeople.length; i++) {
			var person = allPeople[i];
			for (var j = 0; j < person.projects.length; j++) {
				var proj = person.projects[j];
				if (!projectMap.has(proj.id)) {
					projectMap.set(proj.id, {
						id: Number(proj.id),
						name: proj.name,
						latestStatus: proj.latestStatus || statuses[proj.id] || null,
						people: []
					});
				} else if (proj.latestStatus) {
					projectMap.get(proj.id).latestStatus = proj.latestStatus;
				}
				projectMap.get(proj.id).people.push({
					id: Number(person.id),
					name: person.name,
					workhours: person.workhours,
					absences: person.absences || [],
					plan: proj.plan || [],
					worklogHours: proj.worklogHours || []
				});
			}
		}

		// Include projects without plan entries so they still appear in the view
		for (var k = 0; k < allProjects.length; k++) {
			var p = allProjects[k];
			if (!projectMap.has(p.id)) {
				projectMap.set(p.id, {
					id: Number(p.id),
					name: p.name,
					latestStatus: statuses[p.id] || null,
					people: []
				});
			}
		}

		return {
			projects: Array.from(projectMap.values()).sort(function(a, b) {
				return a.name.localeCompare(b.name);
			}),
			allPeople: peopleList.sort(function(a, b) {
				return a.name.localeCompare(b.name);
			})
		};
	};

	// Refresh the options inside all Choices.js instances with current project data
	PM.Plan.refreshProjectChoices = function(projects) {
		if (!projects) {
			return $.get('/api/projects').then(function(data) {
				PM.Plan.refreshProjectChoices(data);
			});
		}

		$('.js-project-name-select').each(function() {
			var $el = $(this);
			var choices = $el.data('choices-instance');
			if (!choices) return;

			var currentVal = $el.val();
			var $row = $el.closest('.js-project-row');
			var personId = $row.data('person-id');
			var rowProjectId = $row.data('project-id');

			// Build set of project IDs assigned to this person in other rows
			var assignedProjectIds = new Set();
			$(`.js-project-row[data-person-id="${personId}"]`).each(function() {
				var pid = $(this).data('project-id');
				if (pid) assignedProjectIds.add(Number(pid));
			});

			// Remove all choices
			choices.clearStore();
			// Add placeholder
			choices.setChoices([
				{ value: '', label: i18next.t('Select or type project name'), selected: false, disabled: false }
			]);
			// Add project options, excluding projects already assigned to this person (except this row's own)
			var options = projects
				.filter(function(p) {
					return !assignedProjectIds.has(Number(p.id)) || Number(p.id) === Number(rowProjectId);
				})
				.map(function(p) {
					return { value: String(p.id), label: p.name, selected: Number(p.id) === Number(rowProjectId) };
				});
			choices.setChoices(options, 'value', 'label', false);
		});
	};

	// Helper: resolve a project ID (find existing by name, or create)
	PM.Plan.resolveProject = function(projectId, projectName) {
		if (projectId) {
			// Update the existing project's name
			return $.ajax({
				url: '/api/projects/' + projectId,
				method: 'PUT',
				contentType: 'application/json',
				data: JSON.stringify({ name: projectName })
			}).then(function(res) { return res.id });
		}

		// New project — fetch all projects and check for a name match
		return $.get('/api/projects').then(function(projects) {
			var matched = projects.find(function(p) {
				return p.name.toLowerCase() === projectName.toLowerCase();
			});
			if (matched) {
				return matched.id;
			}

			// Create a brand-new project
			return $.ajax({
				url: '/api/projects',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({ name: projectName })
			}).then(function(res) { return res.id });
		});
	};

	// Helper: recalculate and re-render the totals row for a person or project
	PM.Plan.renderTotalsRow = function(groupId) {
		var $totalsRow = $('.js-totals-row[data-person-id="' + groupId + '"]');
		if (!$totalsRow.length) return;

		var workhours = parseFloat($totalsRow.attr('data-workhours')) || 0;
		var totalWeeks = PM.Plan.totalWeeks || 48;
		var totals = new Array(totalWeeks).fill(0);
		var personAbsences = [];
		var totalWorklog = 0;

		var gid = groupId.toString();
		if (gid.startsWith('proj-')) {
			var projectId = gid.replace('proj-', '');
			$('.js-person-assign-row[data-project-id="' + projectId + '"]').each(function() {
				var pid = $(this).data('person-id');
				if (pid && PM.Plan.personAbsencesMap) {
					personAbsences = personAbsences.concat(PM.Plan.personAbsencesMap.get(Number(pid)) || []);
				}
				$(this).find('.js-plan-week-input').each(function() {
					var week = parseInt($(this).data('week'));
					var rawVal = $(this).data('raw-value');
					var hours;
					if (rawVal !== undefined && rawVal !== '') {
						hours = parseFloat(rawVal);
					} else {
						var val = $(this).val().trim();
						hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
					}
					if (!isNaN(hours) && week >= 1 && week <= totalWeeks) {
						totals[week - 1] += hours;
					}
				});
				$(this).find('.js-worklog-hours').each(function() {
					totalWorklog += PM.Utils.parseNumber($(this).text().trim()) || 0;
				});
			});
		} else {
			if (PM.Plan.personAbsencesMap) {
				personAbsences = PM.Plan.personAbsencesMap.get(Number(groupId)) || [];
			}
			$('.js-project-row[data-person-id="' + groupId + '"]').each(function() {
				$(this).find('.js-plan-week-input').each(function() {
					var week = parseInt($(this).data('week'));
					var rawVal = $(this).data('raw-value');
					var hours;
					if (rawVal !== undefined && rawVal !== '') {
						hours = parseFloat(rawVal);
					} else {
						var val = $(this).val().trim();
						hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
					}
					if (!isNaN(hours) && week >= 1 && week <= totalWeeks) {
						totals[week - 1] += hours;
					}
				});
				$(this).find('.js-worklog-hours').each(function() {
					totalWorklog += PM.Utils.parseNumber($(this).text().trim()) || 0;
				});
			});
		}

		var html = ejs.rr('/app/plan/templates/totals-row.ejs', {
			personId: groupId,
			totals: totals,
			workhours: workhours,
			personAbsences: personAbsences,
			totalWorklog: totalWorklog,
			viewMode: PM.Plan.viewMode,
			colors: PM.Plan.colors,
			weekStructure: { totalWeeks: totalWeeks }
		});
		$totalsRow.replaceWith(html);
	};

	// Export plan data to CSV
	PM.Plan.exportCsv = function() {
		var planData = PM.Plan._planData;
		if (!planData) return;

		var weekStructure = planData.weekStructure;
		if (!weekStructure || !weekStructure.weeks) return;

		// Read active filters
		var personFilter = $('.js-plan-person-filter').val();
		var projectFilter = $('.js-plan-project-filter').val();

		// Build flat rows
		var rows = [];
		rows.push(['Person', 'Project', 'Year', 'Week', 'Plan Hours', 'Worklog Hours', 'Absence Hours']);

		for (var i = 0; i < planData.people.length; i++) {
			var person = planData.people[i];

			// Apply person filter
			if (personFilter && String(person.id) !== personFilter) continue;

			// Build absence map (person-level, keyed by global week number)
			var absencesByWeek = new Map();
			if (person.absences) {
				for (var a = 0; a < person.absences.length; a++) {
					var abs = person.absences[a];
					absencesByWeek.set(abs.globalWeek, (absencesByWeek.get(abs.globalWeek) || 0) + abs.hours);
				}
			}

			for (var j = 0; j < person.projects.length; j++) {
				var project = person.projects[j];

				// Apply project filter
				if (projectFilter && String(project.id) !== projectFilter) continue;

				// Build plan map (keyed by global week number)
				var planByWeek = new Map();
				if (project.plan) {
					for (var p = 0; p < project.plan.length; p++) {
						var entry = project.plan[p];
						planByWeek.set(entry.week, entry.hours);
					}
				}

				// Build worklog map (keyed by global week number)
				var worklogByWeek = new Map();
				if (project.worklogHours) {
					for (var w = 0; w < project.worklogHours.length; w++) {
						var wl = project.worklogHours[w];
						worklogByWeek.set(wl.week, wl.hours);
					}
				}

				// Output all weeks in the range
				for (var wk = 0; wk < weekStructure.weeks.length; wk++) {
					var weekInfo = weekStructure.weeks[wk];
					var planHours = planByWeek.get(weekInfo.weekNumber) || 0;
					var worklogHours = worklogByWeek.get(weekInfo.weekNumber) || 0;
					var absenceHours = absencesByWeek.get(weekInfo.weekNumber) || 0;

					// Skip weeks with no data at all
					if (planHours === 0 && worklogHours === 0 && absenceHours === 0) continue;

					rows.push([
						person.name,
						project.name,
						String(weekInfo.year),
						String(weekInfo.perYearWeek),
						i18next.format(planHours, 'number', i18next.language, { minimumFractionDigits: 2 }),
						i18next.format(worklogHours, 'number', i18next.language, { minimumFractionDigits: 2 }),
						i18next.format(absenceHours, 'number', i18next.language, { minimumFractionDigits: 2 })
					]);
				}
			}
		}

		// Build CSV string with BOM for Excel UTF-8 support
		// sep= directive tells Excel the delimiter regardless of locale
		var csvContent = '\uFEFFsep=;\r\n';
		for (var r = 0; r < rows.length; r++) {
			var row = rows[r];
			var escaped = [];
			for (var c = 0; c < row.length; c++) {
				var cell = String(row[c]);
				// Escape fields containing semicolons, quotes, or newlines
				if (cell.indexOf(';') !== -1 || cell.indexOf('"') !== -1 || cell.indexOf('\n') !== -1) {
					cell = '"' + cell.replace(/"/g, '""') + '"';
				}
				escaped.push(cell);
			}
			csvContent += escaped.join(';') + '\r\n';
		}

		// Trigger download
		var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		var url = URL.createObjectURL(blob);
		var link = document.createElement('a');
		link.href = url;
		link.download = 'plan_export.csv';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);

		new Notify({ status: 'success', text: i18next.t('CSV exported.'), timeout: 3000 });
	};

	// Helper: update the total column for a project/person row live as the user types
	PM.Plan.updateRowTotal = function($row) {
		var total = 0;
		$row.find('.js-plan-week-input').each(function() {
			var rawVal = $(this).data('raw-value');
			var hours;
			if (rawVal !== undefined && rawVal !== '') {
				hours = parseFloat(rawVal);
			} else {
				var val = $(this).val().trim();
				hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
			}
			if (!isNaN(hours)) total += hours;
		});
		var $totalSpan = $row.find('.js-row-plan-total');
		if ($totalSpan.length) {
			$totalSpan.text(total ? i18next.format(total, 'number', i18next.language, { minimumFractionDigits: 2 }) : '');
		}
	};

	// Helper: reformat all plan week inputs in a row based on their data-raw-value
	PM.Plan.formatPlanInputs = function($row) {
		$row.find('.js-plan-week-input').each(function() {
			var $input = $(this);
			var rawVal = $input.data('raw-value');
			if (rawVal !== undefined && rawVal !== '' && !isNaN(parseFloat(rawVal))) {
				var hours = parseFloat(rawVal);
				$input.val(i18next.format(hours, 'number', i18next.language, { minimumFractionDigits: 2 }));
				$input.attr('data-raw-value', hours).data('raw-value', hours);
			}
		});
	};

	// Helper: collect plan entries from a row (including the plan-id from data-plan-id)
	PM.Plan.collectPlans = function($row) {
		var plans = [];
		$row.find('.js-plan-week-input').each(function() {
			var rawVal = $(this).data('raw-value');
			var hours;
			if (rawVal !== undefined && rawVal !== '') {
				hours = parseFloat(rawVal);
			} else {
				var val = $(this).val().trim();
				hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
			}
			if (!isNaN(hours)) {
				var entry = {
					week: parseInt($(this).data('per-year-week')),
					year: parseInt($(this).data('year')),
					hours: hours
				};
				var planId = $(this).data('plan-id');
				if (planId) {
					entry.id = parseInt(planId);
				}
				plans.push(entry);
			} else {
				var planId = $(this).data('plan-id');
				if (planId) {
					plans.push({
						id: parseInt(planId),
						week: parseInt($(this).data('per-year-week')),
						year: parseInt($(this).data('year')),
						hours: null
					});
				}
			}
		});
		return plans;
	};

	PM.Plan.renderPlanPage = function() {
		PM.Shell.setSidebarActive('plan');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Plan') }]);
		PM.Weekly.onMonthChange = PM.Plan.renderPlanPage;

		if (PM.Plan.isMobile()) {
			PM.Weekly.hideZoomBar();
			return PM.Plan.renderPlanPageMobile();
		}

		var monthRange = PM.Plan.getMonthRange();
		var fromMonth = monthRange.fromMonth;
		var toMonth = monthRange.toMonth;
		var isProjectView = PM.Plan.viewMode === 'projects';

		// Fetch color stops, all projects and the plan data in parallel
		$.when(
			PM.Plan.fetchColors(),
			$.get('/api/projects'),
			$.get('/api/plan?fromMonth=' + fromMonth + '&toMonth=' + toMonth),
			ejs.preloadTemplate('/app/plan/templates/plan.ejs'),
			ejs.preloadTemplate('/app/plan/templates/plan-by-project.ejs'),
			ejs.preloadTemplate('/app/plan/templates/no-projects-row.ejs'),
			ejs.preloadTemplate('/app/plan/templates/no-people-row.ejs'),
			ejs.preloadTemplate('/app/plan/templates/plan-header.ejs'),
			ejs.preloadTemplate('/app/plan/templates/project-row.ejs'),
			ejs.preloadTemplate('/app/plan/templates/person-assign-row.ejs'),
			ejs.preloadTemplate('/app/plan/templates/totals-row.ejs'),
			ejs.preloadTemplate('/app/plan/templates/zoom-bar.ejs')
		)		.done(function(colorsResult, projectsResult, planResult) {
			// $.when wraps each result as [data, statusText, jqXHR]; extract data
			var allProjects = projectsResult[0];
			var planData = planResult[0];
			PM.Plan._planData = planData;
			PM.Plan._allProjects = allProjects;
			var weekStructure = planData.weekStructure || { totalWeeks: 48, monthGroups: [], weeks: [] };
			PM.Plan.totalWeeks = weekStructure.totalWeeks;
			PM.Plan.weekStructure = weekStructure;

			PM.Plan.personAbsencesMap = new Map();
			for (var _i = 0; _i < planData.people.length; _i++) {
				var _p = planData.people[_i];
				PM.Plan.personAbsencesMap.set(Number(_p.id), _p.absences || []);
			}

			if (isProjectView) {
				var projectData = PM.Plan.transformToProjectView(planData, allProjects, planData.projectStatuses);
				PM.Plan.allPeople = projectData.allPeople;
				var data = $.extend({}, projectData, {
					allProjects: allProjects,
					fromMonth: fromMonth,
					toMonth: toMonth,
					colors: PM.Plan.colors,
					viewMode: 'projects',
					weekStructure: weekStructure
				});
				$('.js-page-container').html(ejs.rr('/app/plan/templates/plan-by-project.ejs', data));
				PM.Plan.initPersonChoices();
			} else {
				var data = $.extend({}, planData, {
					allProjects: allProjects,
					fromMonth: fromMonth,
					toMonth: toMonth,
					colors: PM.Plan.colors,
					viewMode: 'people',
					weekStructure: weekStructure
				});
				$('.js-page-container').html(ejs.rr('/app/plan/templates/plan.ejs', data));
				PM.Plan.initProjectChoices();
			}

			PM.Weekly.showZoomBar();

			PM.Weekly.initColumnResize('.js-person-name, .js-project-name, .js-project-name-cell, .js-person-name-cell, .js-col-resize-cell', 'plan-col1-width');

			PM.Weekly._stripeApply = function() {
				$('.js-plan-table').addClass('js-weekly-stripe-mode');
				PM.Weekly.applyStripeColors('.js-project-row, .js-person-assign-row', '.js-plan-week-input');
			};
			PM.Weekly._stripeRemove = function() {
				$('.js-plan-table').removeClass('js-weekly-stripe-mode');
				PM.Weekly.removeStripeColors('.js-project-row, .js-person-assign-row', '.js-plan-week-input');
			};

			if (PM.Weekly.stripeMode) {
				PM.Weekly._stripeApply();
			}

			PM.Weekly.scrollToCurrentMonth('.js-weekly-zoom-container', weekStructure);
			PM.Weekly.highlightCurrentWeek('.js-weekly-zoom-container', weekStructure);
		});
	};

	// Mobile plan page renderer — card-based monthly view
	PM.Plan.renderPlanPageMobile = function() {
		var monthRange = PM.Plan.getMonthRange();
		var fromMonth = monthRange.fromMonth;
		var toMonth = monthRange.toMonth;
		var isProjectView = PM.Plan.viewMode === 'projects';

		$.when(
			PM.Plan.fetchColors(),
			$.get('/api/projects'),
			$.get('/api/plan?fromMonth=' + fromMonth + '&toMonth=' + toMonth),
			ejs.preloadTemplate('/app/plan/templates/plan-mobile.ejs'),
			ejs.preloadTemplate('/app/plan/templates/plan-mobile-header.ejs'),
			ejs.preloadTemplate('/app/plan/templates/select-project-modal.ejs'),
			ejs.preloadTemplate('/app/plan/templates/select-person-modal.ejs')
		).done(function(colorsResult, projectsResult, planResult) {
			var allProjects = projectsResult[0];
			var planData = planResult[0];
			PM.Plan._planData = planData;
			var weekStructure = planData.weekStructure || { totalWeeks: 48, monthGroups: [], weeks: [] };
			PM.Plan.totalWeeks = weekStructure.totalWeeks;
			PM.Plan.weekStructure = weekStructure;

			PM.Plan.personAbsencesMap = new Map();
			for (var _i = 0; _i < planData.people.length; _i++) {
				var _p = planData.people[_i];
				PM.Plan.personAbsencesMap.set(Number(_p.id), _p.absences || []);
			}

			var selectedMonth = PM.Plan.currentMobileMonth;
			var availableMonths = weekStructure.monthGroups.map(function(group) {
				return group.year + '-' + String(group.month + 1).padStart(2, '0');
			});
			if (!availableMonths.includes(selectedMonth)) {
				var today = PM.Weekly.monthOffset(0);
				selectedMonth = availableMonths.includes(today) ? today : availableMonths[0];
				PM.Plan.currentMobileMonth = selectedMonth;
			}
			var currentYear = Number(selectedMonth.slice(0, 4));
			var currentMonth = Number(selectedMonth.slice(5)) - 1;

			if (isProjectView) {
				var projectData = PM.Plan.transformToProjectView(planData, allProjects, planData.projectStatuses);
				PM.Plan.allPeople = projectData.allPeople;
				var data = $.extend({}, projectData, {
					allProjects: allProjects,
					fromMonth: fromMonth,
					toMonth: toMonth,
					colors: PM.Plan.colors,
					viewMode: 'projects',
					weekStructure: weekStructure,
					selectedMonth: selectedMonth,
					currentMonth: currentMonth,
					currentYear: currentYear
				});
				$('.js-page-container').html(ejs.rr('/app/plan/templates/plan-mobile.ejs', data));
			} else {
				var data = $.extend({}, planData, {
					allProjects: allProjects,
					fromMonth: fromMonth,
					toMonth: toMonth,
					colors: PM.Plan.colors,
					viewMode: 'people',
					weekStructure: weekStructure,
					selectedMonth: selectedMonth,
					currentMonth: currentMonth,
					currentYear: currentYear
				});
				$('.js-page-container').html(ejs.rr('/app/plan/templates/plan-mobile.ejs', data));
			}
		});
	};

	// Person filter change — show/hide rows for the selected person
	$(document).on('change', '.js-plan-person-filter', function() {
		var selectedId = $(this).val();

		if ($('.plan-mobile-cards').length) {
			// Mobile card view
			if (selectedId === '') {
				$('.plan-mobile-card').show();
			} else {
				$('.plan-mobile-card').hide();
				$('.plan-mobile-card[data-person-id="' + selectedId + '"]').show();
			}
			return;
		}

		if (selectedId === '') {
			// Show all
			$('.js-person-header, .js-project-row, .js-no-projects-row, .js-totals-row').show();
		} else {
			// Hide all, then show matching
			$('.js-person-header, .js-project-row, .js-no-projects-row, .js-totals-row').hide();
			$(`.js-person-header[data-person-id="${selectedId}"]`).show();
			$(`.js-project-row[data-person-id="${selectedId}"]`).show();
			$(`.js-no-projects-row[data-person-id="${selectedId}"]`).show();
			$(`.js-totals-row[data-person-id="${selectedId}"]`).show();
		}
	});

	// Add project button click
	$(document).on('click', '.js-add-project-btn', function() {
		var personId = $(this).data('person-id');

		// Mobile card view — show a modal
		if ($('.plan-mobile-cards').length) {
			$.get('/api/projects').then(function(projects) {
				var assignedIds = new Set();
				$('.plan-mobile-project-row[data-person-id="' + personId + '"]').each(function() {
					var pid = $(this).data('project-id');
					if (pid) assignedIds.add(Number(pid));
				});
				var available = projects.filter(function(p) {
					return !assignedIds.has(Number(p.id));
				});

				var modalHtml = ejs.rr('/app/plan/templates/select-project-modal.ejs', {
					personId: personId,
					available: available
				});
				var $modal = $(modalHtml);
				$('body').append($modal);
				var bsModal = new bootstrap.Modal($modal[0]);
				bsModal.show();

				$modal.on('hidden.bs.modal', function() {
					$modal.remove();
				});

				$modal.on('shown.bs.modal', function() {
					$modal.find('.js-new-project-name').focus();
				});
			});
			return;
		}

		// Desktop table view — existing logic
		var $noProjectsRow = $(`.js-no-projects-row[data-person-id="${personId}"]`);

		// Remove the "no projects" row if it exists
		if ($noProjectsRow.length) {
			$noProjectsRow.remove();
		}

		// Fetch projects so the new row's <select> has options (exclude already-assigned projects)
		$.get('/api/projects').then(function(projects) {
			// Build set of project IDs already assigned to this person
			var assignedProjectIds = new Set();
			$(`.js-project-row[data-person-id="${personId}"]`).each(function() {
				var pid = $(this).data('project-id');
				if (pid) assignedProjectIds.add(Number(pid));
			});
			var availableProjects = projects.filter(function(p) {
				return !assignedProjectIds.has(Number(p.id));
			});

			var ws = PM.Plan.weekStructure || { totalWeeks: PM.Plan.totalWeeks, weeks: [], monthGroups: [] };
			var rowHtml = ejs.rr('/app/plan/templates/project-row.ejs', {
				personId: personId,
				allProjects: projects,
				availableProjects: availableProjects,
				personAbsences: PM.Plan.personAbsencesMap.get(Number(personId)) || [],
				weekStructure: ws,
				monthStartWeeks: PM.Plan.getMonthStartWeeks(ws)
			});

			// Find the last project row for this person (or the header row)
			var $lastProjectRow = $(`.js-project-row[data-person-id="${personId}"]`).last();
			if ($lastProjectRow.length) {
				$lastProjectRow.after(rowHtml);
			} else {
				// Insert after the person header row
				$(`.js-person-header[data-person-id="${personId}"]`).after(rowHtml);
			}

			// Initialize Choices.js on the newly added select
			var $newRow = $(`.js-project-row[data-person-id="${personId}"]`).last();
			PM.Plan.initProjectChoices($newRow.find('.js-project-name-select'));

			// Apply resize handles to the new row
			PM.Plan.initColumnResize();
			PM.Weekly.highlightCurrentWeek('.js-weekly-zoom-container', ws);

			if (PM.Weekly.stripeMode) {
				PM.Plan.applyStripeColors();
			}
		});
	});

	// Remove project button click
	$(document).on('click', '.js-remove-project-btn', function() {
		var $row = $(this).closest('.js-project-row');
		var personId = $row.data('person-id');
		var projectId = $row.data('project-id');

		if (projectId) {
			// Existing project — confirm before deleting
			if (!confirm(i18next.t('Remove this project from the plan?'))) return;

			PM.Plan.deleteRowEntries($row).done(function() {
				$row.remove();
				PM.Plan.checkNoProjectsRow(personId);
				PM.Plan.renderTotalsRow(personId);
			});
		} else {
			// New unsaved project row — just remove it
			$row.remove();
			PM.Plan.checkNoProjectsRow(personId);
			PM.Plan.renderTotalsRow(personId);
		}
	});

	// Keep data-raw-value in sync when user edits a plan week input
	$(document).on('input', '.js-plan-week-input', function() {
		var val = $(this).val().trim();
		var parsed = val !== '' ? PM.Utils.parseNumber(val) : NaN;
		if (!isNaN(parsed)) {
			$(this).attr('data-raw-value', parsed).data('raw-value', parsed);
		} else {
			$(this).removeAttr('data-raw-value').removeData('raw-value');
		}
		var $row = $(this).closest('.js-project-row, .js-person-assign-row');
		if ($row.length) PM.Plan.updateRowTotal($row);
	});

	// Save on plan week input blur
	$(document).on('blur', '.js-plan-week-input', function() {
		var $input = $(this);
		var $row = $input.closest('.js-project-row, .js-person-assign-row');

		var personId, projectId;

		if ($row.length) {
			personId = $row.data('person-id');
			projectId = $row.data('project-id');
		} else {
			// Mobile card view — data attributes are on the input itself
			personId = $input.data('person-id');
			projectId = $input.data('project-id');
		}

		if (!projectId) return;
		if ($row.length && !$row.hasClass('js-project-row') && !personId) return;

		var plans;
		if ($row.length) {
			plans = PM.Plan.collectPlans($row);
		} else {
			// Mobile: collect plans for this person+project across the visible inputs
			plans = [];
			$('.js-plan-week-input[data-person-id="' + personId + '"][data-project-id="' + projectId + '"]').each(function() {
				var rawVal = $(this).data('raw-value');
				var hours;
				if (rawVal !== undefined && rawVal !== '') {
					hours = parseFloat(rawVal);
				} else {
					var val = $(this).val().trim();
					hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
				}
				if (!isNaN(hours)) {
					var entry = {
						week: parseInt($(this).data('per-year-week')),
						year: parseInt($(this).data('year')),
						hours: hours
					};
					var planId = $(this).data('plan-id');
					if (planId) entry.id = parseInt(planId);
					plans.push(entry);
				} else {
					var planId = $(this).data('plan-id');
					if (planId) {
						plans.push({
							id: parseInt(planId),
							week: parseInt($(this).data('per-year-week')),
							year: parseInt($(this).data('year')),
							hours: null
						});
					}
				}
			});
		}

		$.ajax({
			url: '/api/plan',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				person: {
					id: personId,
					project: {
						id: projectId,
						plan: plans
					}
				}
			})
		})
		.done(function(response) {
			if (response && response.plans) {
				if ($row.length) {
					PM.Plan.updatePlanIds($row, response.plans);
					$row.find('.js-plan-week-input').each(function() {
						var rawVal = $(this).data('raw-value');
						var isEmpty = (rawVal === undefined || rawVal === '') && $(this).val().trim() === '';
						if (isEmpty) {
							$(this).removeAttr('data-plan-id').removeData('plan-id');
						}
					});
				} else {
					// Mobile: update plan IDs on all inputs for this person+project
					response.plans.forEach(function(saved) {
						var $mInput = $('.js-plan-week-input[data-person-id="' + personId + '"][data-project-id="' + projectId + '"][data-per-year-week="' + saved.week + '"][data-year="' + saved.year + '"]');
						if ($mInput.length) {
							$mInput.attr('data-plan-id', saved.id).data('plan-id', saved.id);
							if (saved.hours !== undefined && saved.hours !== null) {
								$mInput.val(i18next.format(saved.hours, 'number', i18next.language, { minimumFractionDigits: 2 }))
									.attr('data-raw-value', saved.hours).data('raw-value', saved.hours);
							}
						}
					});
				}
			}
			if ($row.length) {
				PM.Plan.formatPlanInputs($row);
				if ($row.hasClass('js-project-row')) {
					PM.Plan.renderTotalsRow(personId);
				} else {
					PM.Plan.renderTotalsRow('proj-' + projectId);
				}
			}
			if (PM.Weekly.stripeMode) {
				PM.Plan.applyStripeColors();
			}
		});
	});

	// Save on project selection change
	$(document).on('change', '.js-project-name-select', function() {
		var $select = $(this);
		var $row = $select.closest('.js-project-row');
		var personId = $row.data('person-id');
		var projectId = $row.data('project-id');
		var selectedProjectId = $select.val();
		var resolvedProjectId;

		// If the user cleared the selection, delete the old project's plan and reset the row
		if (!selectedProjectId) {
			if (projectId) {
				PM.Plan.deleteRowEntries($row).done(function() {
					$row.attr('data-project-id', '').data('project-id', '');
					$row.find('.js-project-status-dot').remove();
					$row.find('.js-plan-week-input').removeAttr('data-plan-id').removeData('plan-id');
					$row.find('.js-remove-project-btn').attr('data-project-id', '').data('project-id', '');
					PM.Plan.refreshProjectChoices();
					PM.Plan.renderTotalsRow(personId);
				});
			}
			return;
		}

		// If the value is a number (existing project selected), use it
		// If it's a text value (Choices.js added item), resolve by name
		var isNewProjectName = isNaN(parseInt(selectedProjectId));
		var resolvePromise;

		if (isNewProjectName) {
			// User typed a new project name — resolve by name
			resolvePromise = PM.Plan.resolveProject(null, selectedProjectId);
		} else {
			// Existing project — use the selected ID directly
			resolvePromise = $.Deferred().resolve(parseInt(selectedProjectId));
		}

		resolvePromise
			.done(function(resolvedId) {
				resolvedProjectId = resolvedId;
				var oldProjectId = $row.data('project-id');
				var idsToDelete = oldProjectId ? PM.Plan.rowEntryIds($row) : [];
				var plans = PM.Plan.collectPlans($row).map(function(plan) {
					delete plan.id;
					return plan;
				}).filter(function(plan) { return plan.hours !== null; });
				var deletePromise = PM.Plan.deleteEntryIds(idsToDelete);
				PM.Plan.updateRowProjectId($row, resolvedProjectId);
				$row.find('.js-plan-week-input').removeAttr('data-plan-id').removeData('plan-id');

				if (plans.length > 0) {
					return deletePromise.then(function() {
						return $.ajax({
							url: '/api/plan',
							method: 'POST',
							contentType: 'application/json',
							data: JSON.stringify({
								person: {
									id: personId,
									project: {
										id: resolvedProjectId,
										plan: plans
									}
								}
							})
						});
					});
				} else {
					return deletePromise;
				}
			})
			.done(function(response) {
				if (response && response.plans) {
					PM.Plan.updatePlanIds($row, response.plans);
				}
				PM.Plan.formatPlanInputs($row);
				PM.Plan.refreshProjectChoices();
				PM.Plan.renderTotalsRow(personId);
				PM.Plan.ProjectStatus.refreshDot(resolvedProjectId);
			});
	});

	// Add person button click (project view)
	$(document).on('click', '.js-add-person-btn', function() {
		var projectId = $(this).data('project-id');
		var $noPeopleRow = $('.js-no-people-row[data-project-id="' + projectId + '"]');
		if ($noPeopleRow.length) $noPeopleRow.remove();

		$.get('/api/people').then(function(allPeople) {
			var peopleInPlan = allPeople.filter(function(p) { return p.show_in_plan !== false; });
			PM.Plan.allPeople = peopleInPlan;
			var assignedPersonIds = new Set();
			$('.js-person-assign-row[data-project-id="' + projectId + '"]').each(function() {
				var pid = $(this).data('person-id');
				if (pid) assignedPersonIds.add(Number(pid));
			});

			var availablePeople = peopleInPlan.filter(function(p) {
				return !assignedPersonIds.has(Number(p.id));
			});

			var ws = PM.Plan.weekStructure || { totalWeeks: PM.Plan.totalWeeks, weeks: [], monthGroups: [] };
			var rowHtml = ejs.rr('/app/plan/templates/person-assign-row.ejs', {
				projectId: projectId,
				allPeople: peopleInPlan,
				availablePeople: availablePeople,
				personAbsences: [],
				weekStructure: ws,
				monthStartWeeks: PM.Plan.getMonthStartWeeks(ws)
			});

			var $lastPersonRow = $('.js-person-assign-row[data-project-id="' + projectId + '"]').last();
			if ($lastPersonRow.length) {
				$lastPersonRow.after(rowHtml);
			} else {
				$('.js-project-header[data-project-id="' + projectId + '"]').after(rowHtml);
			}

			var $newRow = $('.js-person-assign-row[data-project-id="' + projectId + '"]').last();
			PM.Plan.initPersonChoices($newRow.find('.js-person-select'));
			PM.Plan.initColumnResize();
			PM.Weekly.highlightCurrentWeek('.js-weekly-zoom-container', ws);

			if (PM.Weekly.stripeMode) {
				PM.Plan.applyStripeColors();
			}
		});
	});

	// Remove person button click (project view)
	$(document).on('click', '.js-remove-person-btn', function() {
		var $row = $(this).closest('.js-person-assign-row');
		var projectId = $row.data('project-id');
		var personId = $row.data('person-id');

		function checkNoPeople(projId) {
			var $existing = $('.js-person-assign-row[data-project-id="' + projId + '"]');
			if ($existing.length === 0) {
				var $header = $('.js-project-header[data-project-id="' + projId + '"]');
				if ($header.length) {
					$.get('/api/people').then(function(allPeople) {
						var peopleInPlan = allPeople.filter(function(p) { return p.show_in_plan !== false; });
						PM.Plan.allPeople = peopleInPlan;
						var ws = PM.Plan.weekStructure || { totalWeeks: PM.Plan.totalWeeks, weeks: [], monthGroups: [] };
						var rowHtml = ejs.rr('/app/plan/templates/person-assign-row.ejs', {
							projectId: projId,
							allPeople: peopleInPlan,
							availablePeople: peopleInPlan,
							personAbsences: [],
							weekStructure: ws,
							monthStartWeeks: PM.Plan.getMonthStartWeeks(ws)
						});
						$header.after(rowHtml);
						var $newRow = $('.js-person-assign-row[data-project-id="' + projId + '"]').last();
						PM.Plan.initPersonChoices($newRow.find('.js-person-select'));
						PM.Plan.initColumnResize();
						PM.Weekly.highlightCurrentWeek('.js-weekly-zoom-container', ws);
						if (PM.Weekly.stripeMode) {
							PM.Plan.applyStripeColors();
						}
					});
				}
			}
		}

		if (personId) {
			if (!confirm(i18next.t('Remove this person from the project?'))) return;

			PM.Plan.deleteRowEntries($row).done(function() {
				$row.remove();
				checkNoPeople(projectId);
				PM.Plan.renderTotalsRow('proj-' + projectId);
			});
		} else {
			$row.remove();
			checkNoPeople(projectId);
			PM.Plan.renderTotalsRow('proj-' + projectId);
		}
	});

	// Person select change (project view) — save on selection
	$(document).on('change', '.js-person-select', function() {
		var $select = $(this);
		var $row = $select.closest('.js-person-assign-row');
		var projectId = $row.data('project-id');
		var selectedPersonId = $select.val();

		if (!selectedPersonId) return;

		var personId = parseInt(selectedPersonId, 10);
		var oldPersonId = $row.data('person-id');

		var idsToDelete = oldPersonId ? PM.Plan.rowEntryIds($row) : [];
		var plans = PM.Plan.collectPlans($row).map(function(plan) {
			delete plan.id;
			return plan;
		}).filter(function(plan) { return plan.hours !== null; });
		var deletePromise = PM.Plan.deleteEntryIds(idsToDelete);
		$row.attr('data-person-id', personId).data('person-id', personId);
		$select.attr('data-person-id', personId).data('person-id', personId);
		$row.find('.js-remove-person-btn').attr('data-person-id', personId).data('person-id', personId);
		$row.find('.js-plan-week-input').attr('data-person-id', personId).data('person-id', personId);
		$row.find('.js-plan-week-input').removeAttr('data-plan-id').removeData('plan-id');

		var savePromise;
		if (plans.length > 0) {
			savePromise = deletePromise.then(function() {
				return $.ajax({
					url: '/api/plan',
					method: 'POST',
					contentType: 'application/json',
					data: JSON.stringify({
						person: {
							id: personId,
							project: {
								id: projectId,
								plan: plans
							}
						}
					})
				});
			});
		} else {
			savePromise = deletePromise;
		}

		savePromise
		.done(function(response) {
			if (response && response.plans) {
				PM.Plan.updatePlanIds($row, response.plans);
			}
			PM.Plan.formatPlanInputs($row);
			PM.Plan.refreshPersonChoices();
			PM.Plan.renderTotalsRow('proj-' + projectId);
		});
	});

	// View toggle — switch between "group by people" and "group by projects"
	$(document).on('click', '.js-view-people, .js-view-projects', function() {
		var view = $(this).data('view');
		if (PM.Plan.viewMode === view) return;
		PM.Plan.viewMode = view;
		PM.Plan.renderPlanPage();
	});

	// Export CSV button click
	$(document).on('click', '.js-export-csv', function(e) {
		e.preventDefault();
		PM.Plan.exportCsv();
	});

	// Stripe mode toggle button — delegated to PM.Weekly (set via _stripeApply/_stripeRemove in renderPlanPage)

	// Project filter change (project view)
	$(document).on('change', '.js-plan-project-filter', function() {
		var selectedId = $(this).val();

		if ($('.plan-mobile-cards').length) {
			if (selectedId === '') {
				$('.plan-mobile-card').show();
			} else {
				$('.plan-mobile-card').hide();
				$('.plan-mobile-card[data-project-id="' + selectedId + '"]').show();
			}
			return;
		}

		if (selectedId === '') {
			$('.js-project-header, .js-person-assign-row, .js-no-people-row, .js-totals-row').show();
		} else {
			$('.js-project-header, .js-person-assign-row, .js-no-people-row, .js-totals-row').hide();
			$('.js-project-header[data-project-id="' + selectedId + '"]').show();
			$('.js-person-assign-row[data-project-id="' + selectedId + '"]').show();
			$('.js-no-people-row[data-project-id="' + selectedId + '"]').show();
			$('.js-totals-row[data-person-id="proj-' + selectedId + '"]').show();
		}
	});

	// ── Column resize ── delegated to PM.Weekly.initColumnResize

	// App startup
	page('/plan', PM.Shell.routeWithPermission('view_plan', PM.Plan.renderPlanPage));
	page.exit('/plan', (ctx, next) => {
		PM.Plan.viewMode = 'people';
		PM.Weekly.hideZoomBar();
		next();
	});

	// Listen for viewport breakpoint crossing and re-render
	PM.Plan._mediaQuery = window.matchMedia('(max-width: 767.98px)');
	PM.Plan._mediaQuery.addEventListener('change', function(e) {
		var isPlanPage = $('.plan-mobile-cards').length > 0 || $('.js-plan-table').length > 0;
		if (isPlanPage) {
			PM.Plan.renderPlanPage();
		}
	});

	// ── Mobile event handlers ──────────────────────────────────

	// Month filter change — re-render with the selected month
	$(document).on('change', '.js-plan-month-filter', function() {
		PM.Plan.currentMobileMonth = $(this).val();
		PM.Plan.renderPlanPage();
	});

	// Toggle card expansion (person/project card header)
	$(document).on('click', '.js-mobile-card-toggle', function() {
		$(this).closest('.plan-mobile-card').toggleClass('js-expanded');
	});

	// Toggle project week grid visibility (tap on project row in card)
	$(document).on('click', '.js-mobile-project-toggle', function(e) {
		if ($(e.target).closest('button, input').length) return;
		var personId = $(this).data('person-id');
		var projectId = $(this).data('project-id');
		var $grid = $('.plan-mobile-week-grid[data-person-id="' + personId + '"][data-project-id="' + projectId + '"]');
		if ($grid.length === 0) {
			$grid = $('.plan-mobile-week-grid[data-person-id="' + personId + '"][data-project-id="' + projectId + '"]');
		}
		$grid.slideToggle(150);
	});

	// Remove project (mobile card view)
	$(document).on('click', '.js-remove-mobile-project-btn', function(e) {
		e.stopPropagation();
		var personId = $(this).data('person-id');
		var projectId = $(this).data('project-id');
		if (!confirm(i18next.t('Remove this project from the plan?'))) return;
		PM.Plan.deleteVisibleEntries(personId, projectId).done(PM.Plan.renderPlanPage);
	});

	// Remove person (mobile card view — project mode)
	$(document).on('click', '.js-remove-mobile-person-btn', function(e) {
		e.stopPropagation();
		var projectId = $(this).data('project-id');
		var personId = $(this).data('person-id');
		if (!confirm(i18next.t('Remove this person from the project?'))) return;
		PM.Plan.deleteVisibleEntries(personId, projectId).done(PM.Plan.renderPlanPage);
	});

	// Add person (mobile card view — project mode)
	$(document).on('click', '.js-add-person-mobile-btn', function() {
		var projectId = $(this).data('project-id');
		$.get('/api/people').then(function(allPeople) {
			var peopleInPlan = allPeople.filter(function(p) { return p.show_in_plan !== false; });
			var assignedIds = new Set();
			$('.js-person-assign-row[data-project-id="' + projectId + '"]').each(function() {
				var pid = $(this).data('person-id');
				if (pid) assignedIds.add(Number(pid));
			});
			$('.plan-mobile-project-row[data-project-id="' + projectId + '"]').each(function() {
				var pid = $(this).data('person-id');
				if (pid) assignedIds.add(Number(pid));
			});
			var available = peopleInPlan.filter(function(p) { return !assignedIds.has(Number(p.id)); });

			var modalHtml = ejs.rr('/app/plan/templates/select-person-modal.ejs', {
				projectId: projectId,
				available: available
			});
			var $modal = $(modalHtml);
			$('body').append($modal);
			var bsModal = new bootstrap.Modal($modal[0]);
			bsModal.show();

			$modal.on('hidden.bs.modal', function() {
				$modal.remove();
			});
		});
	});

	// ── Modal button handlers ─────────────────────────────────

	PM.Plan.selectedMobileWeek = function() {
		return PM.Plan.weekStructure.weeks.find(function(w) {
			return w.year + '-' + String(w.month + 1).padStart(2, '0') === PM.Plan.currentMobileMonth;
		});
	};

	// Select an existing project from the modal
	$(document).on('click', '.js-select-project-btn', function() {
		var personId = $(this).data('person-id');
		var projectId = $(this).data('project-id');
		var monthWs = PM.Plan.selectedMobileWeek();
		$.ajax({
			url: '/api/plan',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				person: { id: personId, project: { id: projectId, plan: [{
					week: monthWs ? monthWs.perYearWeek : 1,
					year: monthWs ? monthWs.year : new Date().getUTCFullYear(),
					hours: 0
				}] } }
			})
		}).done(function() {
			bootstrap.Modal.getInstance($('.js-plan-select-project-modal')[0]).hide();
			PM.Plan.renderPlanPage();
		});
	});

	// Create a new project from the modal
	$(document).on('click', '.js-create-project-btn', function() {
		var personId = $(this).data('person-id');
		var $input = $(this).closest('.modal').find('.js-new-project-name');
		var name = $input.val().trim();
		if (!name) return;

		PM.Plan.resolveProject(null, name).then(function(resolvedId) {
			var monthWs = PM.Plan.selectedMobileWeek();
			return $.ajax({
				url: '/api/plan',
				method: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({
					person: { id: personId, project: { id: resolvedId, plan: [{
						week: monthWs ? monthWs.perYearWeek : 1,
						year: monthWs ? monthWs.year : new Date().getUTCFullYear(),
						hours: 0
					}] } }
				})
			});
		}).done(function() {
			bootstrap.Modal.getInstance($('.js-plan-select-project-modal')[0]).hide();
			PM.Plan.renderPlanPage();
		});
	});

	// Select a person from the modal
	$(document).on('click', '.js-select-person-btn', function() {
		var projectId = $(this).data('project-id');
		var personId = $(this).data('person-id');
		var monthWs = PM.Plan.selectedMobileWeek();
		$.ajax({
			url: '/api/plan',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				person: { id: personId, project: { id: projectId, plan: [{
					week: monthWs ? monthWs.perYearWeek : 1,
					year: monthWs ? monthWs.year : new Date().getUTCFullYear(),
					hours: 0
				}] } }
			})
		}).done(function() {
			bootstrap.Modal.getInstance($('.js-plan-select-person-modal')[0]).hide();
			PM.Plan.renderPlanPage();
		});
	});
})();
